<template>
  <div>
      <div class="form-group" v-if="permission>=1">
          <label>
            {{message}}
          </label>
        <table class="table table-custom-header" style="overflow: hidden">
          <thead>
          <tr>
            <th>{{__("misc.no")}}</th>
            <th>{{__("misc.yes")}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>

             <td v-if="permission > 1" class="matrix-width matrix-center-element">
               <input
                   value="0"
                   type="radio"
                   :class="'saveQuestion custom-radio ' + classRequired"
                   v-model="paramAnswerCanCompile"
                   :name="'question[' + question_survey_id + '][enable_disable_compilation]'"
               />
             </td>
             <td v-else>
                {{ paramAnswerCanCompile == "0" ? "X" : ""}}
             </td>

             <td v-if="permission > 1" class="matrix-width matrix-center-element">
               <input
                   value="1"
                   type="radio"
                   :class="'saveQuestion custom-radio ' + classRequired"
                   v-model="paramAnswerCanCompile"
                   :name="'question[' + question_survey_id + '][enable_disable_compilation]'"
                   @change="populateSubKpiTable()"
               />
             </td>

            <td v-else>
              {{ paramAnswerCanCompile == "1" ? "X" : ""}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="paramAnswerCanCompile == 1 ">
<!--        SHOW QUESTION 12 if paramAnswerCanCompile == 1-->
        <target-kpi
            :is_admin="is_admin"
            :show_ral="show_ral"
            :show_target_bonus="show_target_bonus"
            :limit_indicators="limit_indicators"
            :show_target_euro="show_target_euro"
            :evaluation_chart_id="evaluation_chart_id"
            :question_survey_id="question_survey_id"
            :owner_person_id="owner_person_id"
            :url_add_kpi="url_add_kpi"
            :url_add_existing_kpi="url_add_existing_kpi"
            :permission_add="permission_add"
            :permission_add_new_kpi="permission_add_new_kpi"
            :permission_edit_prize="permission_edit_prize"
            :show_unit_measure="show_unit_measure"
            :show_measures_and_formulas="show_measures_and_formulas"
            :show_typology="show_typology"
            :show_target_100="show_target_100"
            :show_set_consumptive="show_set_consumptive"
            :show_sum_percent_reach_for_weight="show_sum_percent_reach_for_weight"
            :required_classification_on_create_kpi="required_classification_on_create_kpi"
            :show_classification_on_create_kpi="show_classification_on_create_kpi"
            :show_categories_on_create_kpi="show_categories_on_create_kpi"
            :show_esg_on_create_kpi="show_esg_on_create_kpi"
            :show_max_min_targets="show_max_min_targets"
            :show_max_min_prizes="show_max_min_prizes"
            :show_prize_attribute="show_prize_attribute"
            :prize_name="prize_name"
            :show_prize_assigned="show_prize_assigned"

            :show_prize_reached ="show_prize_reached"
            :show_prize_final ="show_prize_final"
            :enable_change_target="enable_change_target"
            :show_bonus_target="show_bonus_target"
            :show_bonus_weight ="show_bonus_weight"
            :show_bonus_rep ="show_bonus_rep"
            :workflow_role_id ="workflow_role_id"
            :show_perc_linear_performance="show_perc_linear_performance"
            :show_pie_graph="show_pie_graph"
            :show_line_chart="show_line_chart"
            :kpi_classifications="kpi_classifications"
            :kpi_esgs="kpi_esgs"
            :kpi_categories="kpi_categories"
            :show_performance_percent="show_performance_percent" 
            :show_kpi_esg_in_chart="show_kpi_esg_in_chart"
            :show_kpi_classification_in_chart="show_kpi_classification_in_chart"
            :show_reach_percent="show_reach_percent"
            :show_percent_reach_for_weight="show_percent_reach_for_weight"

            :lock_weights="lock_weights"
            :read_target="read_target"
            :show_external_conditions="show_external_conditions"
            :pay_item_ral_name="pay_item_ral_name"
            :show_segmentation_info_in_description_modal="show_segmentation_info_in_description_modal"
            :columns_order="columns_order"
            :classification_types="classification_types"
            :kpi_incentive_plan_id="kpi_incentive_plan_id"
            :target_bonus="target_bonus"
            :prize_mode="prize_mode"
            :main_permission="main_permission"
            :show_prize_value="show_prize_value"
            :show_gross_bonus_sum_achieved_on_ral="show_gross_bonus_sum_achieved_on_ral"
            :show_gross_bonus_sum_achieved_plus_internal_conditions_on_ral="show_gross_bonus_sum_achieved_plus_internal_conditions_on_ral"
            :show_gross_bonus_sum_achieved_inline="show_gross_bonus_sum_achieved_inline"
            :approve_kpi="approve_kpi"
            :ref="ref_child"
            :is_archived="is_archived"
            :icon_status_plan="icon_status_plan"
        >
        </target-kpi>
      </div>
  </div>
</template>

<script>
export default {
  created() {
    this.paramAnswerCanCompile = this.answer_can_compile;
  },
  mounted() {

    if( this.permission > 2){
      this.classRequired = "requiredQuestion";
    }
    if ( this.paramAnswerCanCompile  == 1) {
      this.$refs[this.ref_child].populateKpiTable();
    }
  },
  props: {
    permission : {
      type : Number,
      required:true
    },

    main_permission: {
      type: Number,
      required: true,
    },
    message : {
      type : String,
      required:false,
      default : "---MESSAGE NOT SET---"
    },
    answer_can_compile : {
      type : String,
      required : false
    },
    workflow_role_id: {
      type: Number,
      required: true,
    },
    required_classification_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    show_classification_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    show_categories_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    show_esg_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    ref_child : {
      type : String,
      required : true
    },
    show_sum_percent_reach_for_weight: {
      type: Boolean,
      required: true,
    },
    permission_edit_prize: {
      type: Number,
      required: true,
    },
    show_prize_attribute: {
      type: Number,
      required: true,
    },

    //Props for TargetQuestion
    is_admin: {
      type: Boolean,
      required: true,
    },
    read_target: {
      type: Boolean,
      required: true,
    },
    show_ral: {
      type: Boolean,
      required: true,
    },
    show_target_bonus: {
      type: Boolean,
      required: true,
    },
    show_target_euro: {
      type: Boolean,
      required: true,
    },
    limit_indicators: {
      type: Boolean,
      required: true,
    },
    lock_weights: {
      type: Boolean,
      required: true,
    },
    show_prize_value: {
      type: Boolean,
      required: true,
    },
    show_pie_graph: {
      type: Boolean,
      required: true,
    },
    classification_types: {
      type: Array,
      required: true
    },
    show_line_chart: {
      type: Boolean,
      required: true,
    },
    show_performance_percent: {
      type: Boolean,
      required: true,
    }, 
    show_kpi_esg_in_chart: {
      type: Boolean,
      required: true,
    },
    show_kpi_classification_in_chart: {
      type: Boolean,
      required: true,
    },
    show_reach_percent: {
      type: Boolean,
      required: true,
    },
    show_percent_reach_for_weight: {
      type: Boolean,
      required: true,
    },
    show_unit_measure: {
      type: Boolean,
      required: true,
    },
    show_segmentation_info_in_description_modal: {
      type: Boolean,
      required: true,
    },
    show_measures_and_formulas: {
      type: Boolean,
      required: true,
    },
    show_typology: {
      type: Boolean,
      required: true,
    },
    show_target_100: {
      type: Boolean,
      required: true,
    },
    show_set_consumptive: {
      type: Number,
      required: true,
    },
    show_perc_linear_performance: {
      type: Number,
      required: true,
    },
    url_add_kpi: {
      type: String,
      required: true,
    },
    url_add_existing_kpi: {
      type: String,
      required: true,
    },
    permission_add_new_kpi: {
      type: Number,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    show_external_conditions: {
      type: Array,
      required: true,
    },
    show_max_min_targets: {
      type: Number,
      required: true,
    },
    show_max_min_prizes: {
      type: Number,
      required: true,
    },

    permission_add: {
      type: Number,
      required: true,
    },
    owner_person_id: {
      type: Number,
      required: true,
    },
    target_bonus: {
      type: Number,
      required: true,
    },

    kpi_incentive_plan_id: {
      type: Number,
      required: true,
    }, 
    kpi_classifications: {
      type: Array,
      required: false,
    },
    columns_order: {
      type: Array,
      required: false,
    },
    kpi_categories: {
      type: Array,
      required: false,
    },
    kpi_esgs: {
      type: Array,
      required: false,
    },
    kpi_categories: {
      type: Array,
      required: false,
    },
    kpi_esgs: {
      type: Array,
      required: false,
    },
    kpi_esgs: {
      type: Array,
      required: false,
    },
    prize_mode: {
      type: String,
      required: true,
    },

    prize_name: {
      type: String,
      required: true,
    },
    pay_item_ral_name: {
      type: String,
      required: true,
    },
    show_prize_assigned: {
      type: Boolean,
      required: true,
    },
    show_prize_reached: {
      type: Boolean,
      required: true,
    },
    show_prize_final: {
      type: Boolean,
      required: true,
    },
    show_gross_bonus_sum_achieved_on_ral: {
      type: Boolean,
      required: true,
    },
    show_gross_bonus_sum_achieved_plus_internal_conditions_on_ral: {
      type: Boolean,
      required: true,
    },
    show_gross_bonus_sum_achieved_inline: {
      type: Boolean,
      required: true,
    },
    show_bonus_target: {
      type: Boolean,
      required: true,
    },
    show_bonus_weight: {
      type: Boolean,
      required: true,
    },
    show_bonus_rep: {
      type: Boolean,
      required: true,
    },
    approve_kpi: {
      type: Boolean,
      required: true,
    },

    enable_change_target: {
      type: Boolean,
      required: true,
    },
    is_archived: {
      type: Boolean,
      required:false,
      default: true
    },
    icon_status_plan: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
        classRequired : "",
        paramAnswerCanCompile : ""
    };
  },
  methods: {
    populateSubKpiTable(){

      //It will be called when DOM is finally rendered
      this.$nextTick(function() {
        this.$refs[this.ref_child].populateKpiTable();
      })

    },
    readCanCompileParams(){
      if( this.answer_can_compile ){
        this.paramAnswerCanCompile = this.answer_can_compile
      }
    }
  }
};
</script>
<style scoped>
.custom-radio,
.custom-checkbox {
  width: 22px;
  height: 22px;
}

.table-custom-header thead tr th {
  background: #5d95be;
  color: white;
}
.table-custom-header thead tr th a {
  color: white;
}
</style>